import styled from 'styled-components'
import color from '../theme/color'
import font from '../theme/font'

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5rem 0;
  & button {
    display: flex;
    align-items: center;
    font-size: ${font.size.root};
    padding: 0.2rem 0.7rem;
    border: none;

    &.active {
      color: #ffffff;
      background: ${color.primary.pure};
    }
  }

  & .pagination {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  & .action-button {
    color: ${color.grayscale.greyalpha};
  }
`
export const PaginationItem = styled.div`
  display: flex;
  gap: 0.3rem;
`
